import { baseApi } from 'core/api';

const state = () => ({
    _items: null,
    _more: null,
    _total: 0,
    _search: {
        items: null,
        more: null,
        total: 0,
        term: null,
    },
});

const getters = {
    users: (state) => {
        if (state._search.term !== null) {
            return state._search.items;
        } else {
            return state._items;
        }
    },
    usersTotal: (state) => {
        if (state._search.term !== null) {
            return state._search.total;
        } else {
            return state._total;
        }
    },
    usersHaveMore: (state) => {
        if (state._search.term !== null) {
            return state._search.more !== null;
        } else {
            return state._more !== null;
        }
    },
    usersSearchTerm: (state) => state._search.term,
};

const actions = {
    getKioskUsersLoad(retry) {
        let url = 'core/kiosk/users';

        if (!retry && state._more) {
            url = state._more;
        } else if (retry === true) {
            this._setUsersRetryLoading();
        }

        return baseApi
            .get(url)
            .then((response) => {
                this._setUsersLoaded(response.data);

                return response;
            })
            .catch(() => {
                this._setUsersErrorLoading();
            });
    },

    getKioskUsersSearch(term) {
        let url = 'core/kiosk/users/search';

        if (state._search.more) {
            url = state._search.more;
        }

        return baseApi
            .get(url, { params: { term: term } })
            .then((response) => {
                this._setUsersSearchLoaded({
                    term: term,
                    data: response.data,
                });

                return response;
            })
            .catch((errors) => {
                this._setUsersSearchError();

                return errors;
            });
    },

    usersClearSearch() {
        this._setUsersSearchCleared();
    },

    updateKioskUsersById({ id, form }) {
        return form.put(`core/kiosk/users/${id}`).then((response) => {
            this._setUserUpdated(response.data);

            return response;
        });
    },

    deleteKioskUsersById({ id, form }) {
        return form.delete(`core/kiosk/users/${id}`).then((response) => {
            this._setUserDeleted(id);

            return response;
        });
    },

    deleteKioskUsers(form) {
        return form.delete('core/kiosk/users').then((response) => {
            this._setUsersBulkDeleted(form.ids);

            return response;
        });
    },

    userCreated(user) {
        this._setUserCreated(user);
    },

    userUpdated(user) {
        this._setUserUpdated(user);
    },

    userDeleted({ id }) {
        this._setUserDeleted(id);
    },

    usersBulkDeleted(ids) {
        this._setUsersBulkDeleted(ids);
    },

    // Private methods
    _setUserCreated(data) {
        if (this._items === null) {
            return;
        }

        this._items.unshift(data);
        ++this._total;
    },

    _setUserUpdated(data) {
        if (this._items === null) {
            return;
        }

        this._items = this._items.map((o) => {
            if (o.id === data.id) {
                return data;
            } else {
                return o;
            }
        });

        if (this._search.results) {
            this._search.results = this._search.results.map((o) => {
                if (o.id === data.id) {
                    return data;
                } else {
                    return o;
                }
            });
        }
    },

    _setUserDeleted(id) {
        if (this._items === null) {
            return;
        }

        this._items = this._items.filter((o) => o.id !== id);
        --this._total;

        if (this._search.results) {
            this._search.results = this._search.results.filter((o) => o.id !== id);
        }
    },

    _setUsersBulkDeleted(ids) {
        if (!this._items) return;

        this._items = this._items.filter((o) => {
            return ids.indexOf(o.id) === -1;
        });

        this._total = this._total - ids.length;

        if (this._search.results) {
            this._search.results = this._search.results.filter((o) => {
                return ids.indexOf(o.id) === -1;
            });
        }
    },

    _setUsersLoaded(data) {
        if (this._more) {
            for (let i in data.data) {
                this._items.push(data.data[i]);
            }
        } else {
            this._items = data.data;
        }

        this._more = data.next_page_url;
        this._total = data.total;
    },

    _setUsersRetryLoading() {
        this._items = null;
        this._more = null;
        this._total = 0;
        this._search = {
            items: null,
            more: null,
            total: 0,
            term: null,
        };
    },

    _setUsersErrorLoading() {
        this._items = false;
        this._more = null;
        this._total = 0;
        this._search = {
            items: null,
            more: null,
            total: 0,
            term: null,
        };
    },

    _setUsersSearchLoaded({ term, data }) {
        this._search.items = data.data;
        this._search.more = data.next_page_url;
        this._search.total = data.total;
        this._search.term = term;
    },

    _setUsersSearchError() {
        this._search = {
            items: null,
            more: null,
            total: 0,
            term: null,
        };
    },

    _setUsersSearchCleared() {
        this._search = {
            items: null,
            more: null,
            total: 0,
            term: null,
        };
    },
};

export default {
    state,
    getters,
    actions,
};
